(function($) {
    $(document).ready(function() {
        let onHomePage = exists('#home-conditions');
        let offCanvasExists = exists('.offcanvas-conditions');
        if (!onHomePage && !offCanvasExists) {
            return;
        }

        const refreshInfoCenter = function() {
            $.ajax({
                url: wpApiSettings.root + wpApiSettings.namespace + '/conditions',
                type: "GET",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
                }
            }).done(function(r) {
                let cfs_icon = (parseInt(r['dam_release_cfs']) > parseInt(r['pineville_guage_cfs'])) ? r['dam_waterflow_cfs_icon'] : r['pineville_guage_cfs_icon'];

                $('.info-center-weather-icon').attr('src', 'wp-content/themes/JointsWP/assets/images/information_center/white/'+r['weather_icon']['white']); // update weather icon
                $('.info-center-temp').html(r['temp'] + '° / ' + r['weather_type']); // update weather type and temp
                $('.info-center-sunrise').html('Sunrise ' + r['sunrise']); // update sunrise
                $('.info-center-sunset').html('Sunset ' + r['sunset']); // update sunset

                $('.info-center-cfs-icon').attr('src', 'wp-content/themes/JointsWP/assets/images/information_center/white/'+cfs_icon); // update flow icon
                $('.info-center-dam-cfs').html(r['dam_release_cfs'] + ' CFS Dam Release'); // update dam release cfs
                $('.info-center-pine-cfs').html(r['pineville_guage_cfs'] + ' CFS Pineville Gauge'); // update pineville gauge cfs
            });
        }

        setInterval(refreshInfoCenter, 1000*60*15); // refresh every 15 minutes
    })

    function exists(el) {
        return $(el).length > 0;
    }
})(jQuery);